module.exports = "<!-- Wrapper-->\r\n<div id=\"wrapper\">\r\n\r\n    <!-- Left navigation bar -->\r\n    <navigation></navigation>\r\n\r\n    <!-- Main page wrapper -->\r\n    <div id=\"page-wrapper\" class=\"original-gray-bg\">\r\n\r\n        <!-- Top navigation -->\r\n        <topnavbar></topnavbar>\r\n\r\n       \r\n        <!-- Main view/routes wrapper-->\r\n        <router-outlet></router-outlet>\r\n\r\n        <!-- Footer -->\r\n        <footer></footer>\r\n\r\n    </div>\r\n    <!-- End page wrapper-->\r\n\r\n</div>\r\n<!-- End wrapper-->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/adminLayout.template.html
// module id = 1089
// module chunks = 0